import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-audio-prev",
  templateUrl: "./med-icon-audio-prev.component.html",
})
export class MedIconAudioPrevComponent extends SvgMixinComponent {}
